const aiDataPolicy = {
  title: "AI & Data Policy",
  updated: "2026-09-15",
  intro:
    "Grassurn Technologies builds AI systems for clients. This page explains how we handle client data in that work, separate from the website privacy practices covered in our Privacy Policy.",
  sections: [
    {
      heading: "We do not train on your data",
      body: [
        "Data you or your organisation share with us for an engagement such as documents, datasets, system access, or anything else is used only to deliver that engagement. We do not use client data to train, fine-tune, or otherwise improve any AI or machine-learning model, ours or a third party's, beyond the scope agreed in your statement of work.",
      ],
    },
    {
      heading: "Subprocessors",
      body: [
        "Delivering engagements involves a small set of infrastructure and model providers: cloud infrastructure providers (for example AWS, GCP or Azure) for compute and storage, and AI model providers (for example OpenAI or Anthropic) for inference which are chosen per project and disclosed to the client before use.",
        "For the website itself, MongoDB Atlas stores form submissions and job applications, and PostHog provides analytics. See our Privacy Policy for how those apply to site visitors.",
      ],
    },
    {
      heading: "Retention",
      body: [
        "Engagement data is retained for the length of the engagement and any agreed support period, then deleted or returned per the statement of work. Website leads and job applications stored in MongoDB Atlas are kept only as long as reasonably needed to respond to them or evaluate a candidate, and resumes are deleted after the hiring decision window closes.",
      ],
    },
    {
      heading: "Confidentiality and NDA posture",
      body: [
        "Our team operates under confidentiality obligations for every engagement, and we sign a mutual NDA before any client materials, systems, or data are shared where a client asks for one. Access to client data is limited to the people actually staffed on that engagement.",
        "These confidentiality obligations survive the end of the engagement & they don't expire the day the project wraps up.",
      ],
    },
  ],
};

export default aiDataPolicy;
